import { Component, OnInit } from '@angular/core';
import { ToastyConfig } from "ng2-toasty";
import { PrimeNG } from 'primeng/config';

declare let AdminLTE: any;

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  body: HTMLBodyElement = document.getElementsByTagName('body')[0];

  constructor(
    private toastyConfig: ToastyConfig,
    private primeng: PrimeNG,
  ) {
    this.toastyConfig.theme = 'material';
    this.body.classList.add('skin');
    this.body.classList.add('sidebar-mini');
  }

  ngOnInit() {
    AdminLTE.init();

    // Tradução global pt-BR do PrimeNG (substitui o antigo [locale]="pt" dos p-calendar)
    this.primeng.setTranslation({
      accept: 'Sim',
      reject: 'Não',
      apply: 'Aplicar',
      clear: 'Limpar',
      cancel: 'Cancelar',
      today: 'Hoje',
      weak: 'Fraca',
      medium: 'Média',
      strong: 'Forte',
      passwordPrompt: 'Digite a senha',
      emptyMessage: 'Nenhum resultado encontrado',
      emptyFilterMessage: 'Nenhum resultado encontrado',
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Se', 'Sá'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      dateFormat: 'dd/mm/yy',
      firstDayOfWeek: 0,
      weekHeader: 'Sem',
    });
  }

}
